import { render } from "./pb-pagetext.vue?vue&type=template&id=ae297244&scoped=true"
import script from "./js/pb-pagetext.js?vue&type=script&lang=js&external"
export * from "./js/pb-pagetext.js?vue&type=script&lang=js&external"

import "./pb-pagetext.vue?vue&type=style&index=0&id=ae297244&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae297244"]])

export default __exports__